/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const ColorThemeSwatch = (props) => {
  const halfSize = props.size / 2;
  const beginCircleX = (props.strokeWidth * 2);
  return (
    <svg
      width={props.size}
      height={props.size}
      style={{ transform: 'rotate(-45deg)', cursor: 'pointer' }}
      onClick={props.onClick}
    >
      <circle
        cx={halfSize}
        cy={halfSize}
        r={((halfSize - props.strokeWidth) + 1)}
        stroke={`rgba(${props.highlightColor.r},${props.highlightColor.g},${props.highlightColor.b},${props.highlightColor.a})`}
        strokeWidth={props.strokeWidth}
        fill="none"
        style={{ display: (props.isSelected ? 'block' : 'none') }}
      />
      <path d={`M${props.size - beginCircleX},${halfSize} a1,1 0 1,0 -${props.size - (beginCircleX * 2)},0`} fill={`rgba(${props.baseColor.r},${props.baseColor.g},${props.baseColor.b},${props.baseColor.a})`} />
      <path d={`M${beginCircleX},${halfSize} a1,1 0 0,0 ${props.size - (beginCircleX * 2)},0`} fill={`rgba(${props.accentColor.r},${props.accentColor.g},${props.accentColor.b},${props.accentColor.a})`} />
    </svg>
  );
};

ColorThemeSwatch.propTypes = {
  baseColor: PropTypes.object,
  accentColor: PropTypes.object,
  highlightColor: PropTypes.object,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ColorThemeSwatch;
